import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enMainPahe from './English/mainpage.json';
import enAuthForm from './English/AuthForm.json';
import enSider from './English/sider.json';
import enPanel from './English/Panel.json';

import faManPage from './Farsi/mainpage.json';
import faAuthForm from './Farsi/AuthForm.json';
import faSider from './Farsi/sider.json';
import faPanel from './Farsi/Panel.json';

const resources = {
  en: {
    mainpage: enMainPahe,
    authForm: enAuthForm,
    sider: enSider,
    panel: enPanel,
  },
  fa: {
    mainpage: faManPage,
    authForm: faAuthForm,
    sider: faSider,
    panel: faPanel,
  },
};

const customLanguageDetector = {
  type: 'languageDetector',
  async: false,

  detect: () => {
    const cachedLanguage = localStorage.getItem('i18nextLng');
    const language =
      cachedLanguage || navigator.language || navigator.userLanguage;

    return language.startsWith('fa') ? 'fa' : 'en';
  },

  init: () => {},

  cacheUserLanguage: (lng) => {
    if (lng) {
      localStorage.setItem('i18nextLng', lng);
    }
  },
};

i18n
  .use(customLanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
